import { curry } from 'ramda';

import { CountryAddressField, TCountry } from './countries.types';

export const isAddressFieldOptional = curry((country: TCountry, fieldName: CountryAddressField): boolean =>
  country.validation.optionalFields.includes(fieldName),
);
